import { PermissionsConstrains } from "@/enums/permissions.enum";
import { TaxInterface } from "@/interface/business/item.interface";
import { TaxType } from "@/types/business/item.type";
import { FORM_TYPE } from "@/enums/apps.enum";

export class Tax implements TaxInterface {
  id: string = "";
  name: string = "";
  rate: number = 0;
  inclusion_type: string = "";
  is_custom_amount: boolean = true;
  created_at: Date = new Date();
  updated_at: Date = new Date();
  type: string = "";
  rate_formatted?: number = 0;
  applied: number = 0;
  formType: string = FORM_TYPE.CREATE;

  public static MODULE = PermissionsConstrains.CATALOG_TAX;

  constructor(data: TaxType) {
    if (data) {
      this.id = data.id || "";
      this.name = data.name || "";
      this.applied = data.applied || 0;
      this.type = data.type || "";
      this.rate = +data.rate || 0;
      this.inclusion_type = data.inclusion_type || "";
      this.is_custom_amount = data.is_custom_amount || false;
      this.rate_formatted = this.getRateFormatted() || 0;
    }
    this.created_at = this.created_at || new Date();
    this.updated_at = this.updated_at || new Date();
  }

  setFormCreate(): void {
    this.formType = FORM_TYPE.CREATE;
  }

  setFormEdit(): void {
    this.formType = FORM_TYPE.EDIT;
  }

  setFormPreview(): void {
    this.formType = FORM_TYPE.PREVIEW;
  }

  isFormCreate(): boolean {
    return this.formType === FORM_TYPE.CREATE;
  }

  isFormEdit(): boolean {
    return this.formType === FORM_TYPE.EDIT;
  }

  isFormPreview(): boolean {
    return this.formType === FORM_TYPE.PREVIEW;
  }

  /***
   * Function to format rate value
   * @return {string}
   */
  getRateFormatted(): number {
    return Math.round(Number(`${(this.rate * 100).toFixed(2)}`));
  }

  /**
   * assign rate value to rate , if rate is empty will assign it to -1
   */
  public setRate(rate) {
    if (!rate) {
      this.rate = -1;
      return;
    }
    this.rate = rate / 100;
    this.rate.toFixed(2);
  }
}
